module.exports = __webpack_public_path__ + "img/app-pro-sync.f4b1bc6d.webp";